import { Link } from "react-router-dom";
import SectionFadeIn from "@/components/SectionFadeIn";
import { useTranslation } from 'react-i18next';

const serviceImages = [
  "/services/facade-inspection.webp",
  "/services/parapet-roof-inspection.webp",
  "/services/leak-investigation.webp",
  "/services/structural-masonry-repair.webp",
  "/services/dob-violations.webp",
  "/services/engineering-reports.webp",
  "/services/contract-templates.webp",
];

const servicePaths = [
  "/services/facade-inspection",
  "/services/parapet-inspection",
  "/services/leak-investigation",
  "/services/structural-repairs",
  "/services/dob-violations",
  "/services/engineering-reports",
  "/services/contract-templates",
];

const ServicesGrid = () => {
  const { t, i18n } = useTranslation('home');
  const prefix = i18n.language === 'es' ? '/es' : '';

  const serviceItems = t('servicesGrid.items', { returnObjects: true }) as Array<{ title: string; desc: string }>;

  const services = Array.isArray(serviceItems) ? serviceItems.map((item, i) => ({
    title: item.title,
    desc: item.desc,
    image: serviceImages[i],
    path: servicePaths[i],
  })) : [];

  return (
    <section className="section-padding">
      <div className="container-max">
        <SectionFadeIn>
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">{t('servicesGrid.title')}</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">{t('servicesGrid.subtitle')}</p>
          </div>
        </SectionFadeIn>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <SectionFadeIn key={service.title} delay={i * 0.05}>
              <Link to={`${prefix}${service.path}`} className="group block overflow-hidden rounded-sm border border-border hover:shadow-md transition-all">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    width={480}
                    height={320}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute bottom-0 left-0 right-0 h-1 bg-brand-yellow transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-accent transition-colors">{service.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{service.desc}</p>
                </div>
              </Link>
            </SectionFadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
